import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Banner, Stack } from '@optimus-web/core';
import { WithFieldsConfig } from './fields/types';

interface RateFormBannersProps extends WithFieldsConfig {
    enterpriseCount: number;
    selectedRatesCount?: number;
    dependent?: boolean;
}

export const RateFormBanners = ({
    selectedRatesCount,
    enterpriseCount,
    fieldsConfig,
    dependent,
}: RateFormBannersProps) => {
    if (selectedRatesCount === 1) {
        return null;
    }

    const primaryInfoTextCreateDependent =
        enterpriseCount > 1
            ? TextKey.RateBulkCreateDependentRateBanner
            : TextKey.RateBulkCreateDependentRateBannerSingleProperty;
    const primaryInfoTextEdit =
        enterpriseCount > 1 ? TextKey.RateBulkEditMultipleProperties : TextKey.RateBulkEditSingleProperty;
    const primaryInfoTextCreateBase =
        enterpriseCount > 1 ? TextKey.RateBulkCreateBaseRateBanner : TextKey.RateBulkCreateBaseRateBannerSingleProperty;

    return (
        <>
            {fieldsConfig?.lockedFields?.length ? (
                <Banner
                    variant="warning"
                    primaryText={<LocalizedText textKey={TextKey.RatesDifferentValuesWarning} />}
                    secondaryText={<LocalizedText textKey={TextKey.RatesFieldsWithDifferentValuesAreLocked} />}
                />
            ) : null}

            <Banner
                variant="info"
                primaryText={
                    selectedRatesCount ? (
                        <LocalizedText textKey={primaryInfoTextEdit} />
                    ) : (
                        <LocalizedText
                            textKey={dependent ? primaryInfoTextCreateDependent : primaryInfoTextCreateBase}
                        />
                    )
                }
                secondaryText={
                    <Stack spacing="50" vertical>
                        {selectedRatesCount && selectedRatesCount > 1 ? (
                            <Stack>
                                <LocalizedText
                                    textKey={TextKey.RatesCountMessage}
                                    substitutes={{ numberOfRates: selectedRatesCount }}
                                />
                            </Stack>
                        ) : null}
                        <Stack>
                            <LocalizedText
                                textKey={TextKey.PropertiesCountMessage}
                                substitutes={{ numberOfProperties: enterpriseCount }}
                            />
                        </Stack>
                    </Stack>
                }
            />
        </>
    );
};
